module.exports = __webpack_public_path__ + "img/box5-01.f0edd377.png";